import {createFeatureSelector, createSelector, MemoizedSelector} from "@ngrx/store";
import {DATA_SOURCES_ALL_STATE_NAME, DataSourcesAllState} from "./dataSourcesAll";
import {Serializer, Serializers} from "../../interfaces/serializer";
import {DataSource} from "../../interfaces/data-source";

export const selectDataSourcesAllState = createFeatureSelector<DataSourcesAllState>(DATA_SOURCES_ALL_STATE_NAME);

export const selectDataSourcesAll = createSelector(
  selectDataSourcesAllState,
  (dataSourcesState: DataSourcesAllState) => dataSourcesState.dataSources
);

export const selectDataSourceCustom: MemoizedSelector<object, Serializer<DataSource>> = createSelector(
  selectDataSourcesAll,
  (datasources: Serializers<DataSource>): Serializer<DataSource> => datasources.find((datasource: Serializer<DataSource>): boolean => datasource.attributes.slug === 'custom-advertising')
)

export const selectDataSourcesAllLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesAllState,
  (dataSourcesState: DataSourcesAllState) => dataSourcesState.loading
);

export const selectDataSourcesAllLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourcesAllState,
  (dataSourcesState: DataSourcesAllState) => dataSourcesState.loaded
);
